import { AdminPageShell } from "@/components/admin/admin-page-shell";
import { NewAccountForm } from "@/components/admin/new-account-form";

export function AdminProfessionalNew() {
  return (
    <AdminPageShell
      title="Nueva cuenta"
      description="Elegí plan, días de prueba y si la persona define contraseña por email o vos la cargás. Pro/Enterprise sin prueba quedan con pago pendiente en el panel."
    >
      <NewAccountForm />
    </AdminPageShell>
  );
}
